(function() {
'use strict';

angular
    .module('TR')
    .directive('slider', slider);

function slider() {
    return {
        restrict: 'A',
        scope: {
            config: '=',
            model: '=',
            dual: '@',
            range: '@',
            step: '@',
            showLabel: '@',
            slidecomplete: '&',
        },

        link(scope, elem, attrs) {
            let modelWatcher;
            let setSliderPosition;
            let dual = attrs.dual === 'true';
            const showLabel = attrs.showLabel === 'true';

            const configWatcher = scope.$watch('config', function(config) {
                if (!_.isEmpty(config)) {
                    configWatcher();

                    const setup = {
                        range: attrs.range,
                        dual,
                        step: parseFloat(scope.step),
                        min: config.Min,
                        max: config.Max,
                        edgesBecomeNull: config.edgesBecomeNull || {},
                        slide(event, ui) {
                            scope.$apply(() => {
                                scope.model = dual ? ui.model : _.get(ui.model, 'Min', null);
                            });
                        },
                        stop() {
                            scope.$apply(() => scope.slidecomplete());
                        }
                    };

                    setSliderPosition = $(elem).rtlSlider(setup);
                    watchModel();
                }
            }, true);

            function watchModel() {
                modelWatcher && modelWatcher();
                modelWatcher = scope.$watch('model', function(val, old) {
                    if (setSliderPosition.hasBeenCalled && angular.equals(val, old)) {
                        return;
                    }
                    let model = angular.isNumber(val) ? { Min: val, Max: val, } : val;
                    setSliderPosition(model);
                    setSliderPosition.hasBeenCalled = true;
                    if (showLabel) {
                        $(elem).children().text(val);
                    }
                }, true);
            }
        }
    };
}
})();
